import Component from "@base/js/component";

export default class ArticleBody extends Component {
  // Defines the element selector which will initialize this component
  static selector = ".article-body";

  static children = {
    tables: ["table"],
    horizontalSeperator: ["hr"],
    anchors: ['a[href^="#"]'],
  };

  // Will be called upon component instantiation
  afterInit() {
    /* eslint-disable no-console */
    const olStart = document.querySelector(".article-body ol[start]");
    if (olStart) {
      const start = parseInt(olStart.getAttribute("start"), 10) - 1;
      olStart.style.setProperty(
        "--start-count",
        Number.isInteger(start) ? start : 0
      );
    }

    const themeBar = document.querySelector(".theme-bar");
    const { tables, horizontalSeperator, anchors } = this.children;

    if (anchors && anchors.length > 0) {
      anchors.forEach((anchor) => {
        anchor.addEventListener(
          "click",
          (e) => {
            e.preventDefault();

            const refId = e.currentTarget.hash.substring(1);
            if (refId) {
              let targetElement = document.getElementById(refId);
              if (!targetElement) {
                targetElement = document.querySelector(`[name="${refId}"`);
              }

              if (
                targetElement?.parentElement?.tagName === "LI" &&
                targetElement?.closest(".end-of-page-body-copy")
              ) {
                targetElement = targetElement.parentElement;
              }

              targetElement?.scrollIntoView(true);
            }
          },
          { capture: true }
        );
      });
    }

    if (horizontalSeperator && horizontalSeperator.length > 0) {
      horizontalSeperator.forEach((table) => {
        table.setAttribute("aria-hidden", "true");
      });
    }

    if (!(themeBar && tables)) return;

    tables.forEach((table) => {
      table.classList.add(`table--${themeBar.dataset.theme}`);
    });
  }
}
// Remove this line if this component is not intended
// to initialize on DOM load.
ArticleBody.init();
